import PropTypes from 'prop-types';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

const StudyLevelPreview = ({ value, defaultValue = null }) => {
  const { t } = useTranslation('common');
  return !value ? defaultValue : t(`studyLevels.${value}`);
};

export default memo(StudyLevelPreview);

StudyLevelPreview.propTypes = {
  defaultValue: PropTypes.any,
  value: PropTypes.string
};
